// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
import 'third/jquery.serviceNetworkFilter';

export default class ServiceNetworkFilter extends WebComponent {
	didMount() {
        $(this.element).serviceNetworkFilter();
    }
}


// WEBPACK FOOTER //
// ./fe/web-gmeinder/src/js/components/ServiceNetworkFilter.js